import { Reveal, Eyebrow } from "@/components/Reveal";

const PageHero = ({ eyebrow, title, intro, children }) => (
  <section className="relative overflow-hidden bg-[#FAF9F6] texture-grain pt-36 pb-14 sm:pt-44 sm:pb-20">
    <div className="absolute -top-32 right-0 w-[28rem] h-[28rem] rounded-full bg-emerald-900/6 blur-3xl pointer-events-none" />
    <div className="relative max-w-4xl mx-auto px-5 sm:px-8">
      <Reveal>
        {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
        <h1 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.08] tracking-tight text-slate-950">
          {title}
        </h1>
        {intro && (
          <p className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed max-w-2xl">
            {intro}
          </p>
        )}
        {children}
      </Reveal>
    </div>
  </section>
);

export default PageHero;
